// extracted by mini-css-extract-plugin
module.exports = {"finalText":"manufacturer-approved-drawer_finalText__xWMIS","externalLinkIcon":"manufacturer-approved-drawer_externalLinkIcon__kjiiP"};